export const percentageToValue = (totalValue, percentage) => {
  if (typeof totalValue !== 'number' || typeof percentage !== 'number') {
    throw new Error('All the parameters must to be numbers');
  }
  return (totalValue * percentage) / 100;
};

export const valueToPercentage = (totalValue, value) =>
  (100 * value) / totalValue;
